import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getCategoriesById (categoryId, callback) {
    HTTP.get('categories/' + categoryId).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: id is required')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/categories/index.js